
import { Module, ActionContext } from 'vuex'
import { RootState, LocationCustomFieldsState } from './state_models'
import locationService from '../services/LocationServices'

export const locationCustomFields: Module<LocationCustomFieldsState, RootState> = {
  namespaced: true,
  state: { customFields: [], customFieldFolders:[], locationId: undefined } as LocationCustomFieldsState,
  getters: {
    getCustomFields(state: LocationCustomFieldsState) {
      return [...state.customFields.filter(f=>!f.standard)];
    },
    getCustomFieldsWithStandardFields(state: LocationCustomFieldsState) {
      return [...state.customFields];
    },
    getCustomFieldFolders(state: LocationCustomFieldsState) {
      return [...state.customFieldFolders];
    },
    getLocationId (state: LocationCustomFieldsState) {
      return (locationId: string) => state.customFields.filter(f=>f.locationId === locationId && !f.standard)
    },
    getByLocationAndType (state: LocationCustomFieldsState) {
      return (locationId: string, model: string) => state.customFields.filter(a=> a.locationId === locationId && a.model === model && !a.standard)
    }
  },
  mutations: {
    setCustomFields (state, customFields) {
      state.customFields = [...customFields];
    },
    setCustomFieldFolders (state, customFields) {
      state.customFieldFolders = [...customFields];
    },
    setLocationId (state, locId) {
      state.locationId = locId;
    },
    clearAll(state) {
      state.customFields = [];
      state.locationId = null
    }
  },
  actions: {
    async syncAll(
      context: ActionContext<LocationCustomFieldsState, RootState>,
      params: { locationId: string, forceRefresh?: boolean}
    ) {
      if(!params || !params.locationId) {
        context.commit('clearAll')
        return
      }

      const locationId = params.locationId;

      if (!params.forceRefresh && context.state.locationId === locationId) return;

      const res = await locationService.CustomFields.search(
        locationId,
        '',
        0,
        10000,
        'folder',
        '',
        'all'
      )
      const folders = res.customFieldFolders;
      const res1 = await locationService.CustomFields.search(
        locationId,
        '',
        0,
        10000,
        'field',
        '',
    'all'
      )
      const fields = res1.customFields.map(f => {
        f.edit = false
        if(f.dataType==='FILE_UPLOAD')
        {
          f.multiple_files_allowed = f.isMultiFileAllowed
          f.multi_file_limit = f.maxFileLimit
        }
        return f
      })

      if (fields) {
        context.commit('setCustomFields',fields);
        context.commit('setLocationId',params.locationId);
      }
      if(folders){
        context.commit('setCustomFieldFolders',folders);
      }
    },
    async getCustomFields(context: ActionContext<LocationCustomFieldsState, RootState>,params: { locationId: string}){
      if(context.state.locationId !== params.locationId)
      await context.dispatch('syncAll',{locationId:params.locationId})
      return context.getters.getCustomFields
    },
    async getCustomFieldsWithStandardFields(context: ActionContext<LocationCustomFieldsState, RootState>,params: { locationId: string}){
      if(context.state.locationId !== params.locationId)
      await context.dispatch('syncAll',{locationId:params.locationId})
      return context.getters.getCustomFieldsWithStandardFields
    },
    async getCustomFieldFolders(context: ActionContext<LocationCustomFieldsState, RootState>,params: { locationId: string}){
      if(context.state.locationId !== params.locationId)
      await context.dispatch('syncAll',{locationId:params.locationId})
      return context.getters.getCustomFieldFolders
    },
    async getByLocationAndType(context: ActionContext<LocationCustomFieldsState, RootState>,params: { locationId: string,model:string}){
      if(context.state.locationId !== params.locationId)
      await context.dispatch('syncAll',{locationId:params.locationId})
      return context.getters.getByLocationAndType(params.locationId,params.model)
    },
    logout: {
      root: true,
      handler: async (context: ActionContext<LocationCustomFieldsState, RootState>) => {
        context.commit('clearAll')
      }
    },
    clearAll: {
      handler: async (context: ActionContext<LocationCustomFieldsState, RootState>) => {
        context.commit('clearAll')
      }
    }
  }
}
